<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {onMount} from 'svelte';
    import MultiSelection from '../MultiSelectItem.svelte';
    import Select from 'svelte-select';
    import {submit} from '../../Form/utils.js';
    import {sgettext} from '../../../i18n.js';
    import {get} from '../../../utils.js';

    export let elementId = null;
    export let readOnly = false;
    export let isDisabled = false;
    $: elementTagsUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/${elementId}/element_tags/`;
    $: setElementTagsUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/${elementId}/set_element_tags/`;
    const availableTagsUrl = `${PATH_PREFIX}/sw/api/elements_database/element_tags/`;

    $: {
        if (elementId)
            getElementTags();
    }

    let elementTags = [];
    let availableTags = [];
    let loadingTags = false;
    let isSearchable = true;
    let tagLimitExceeded = false;

    onMount(async () => {
        if (elementId)
            await getElementTags();
    });

    async function getElementTags() {
        try {
            const resp = await get(elementTagsUrl);
            elementTags = await resp.json();
        }
        catch (err) {
            console.log(err);
        }
    }

    async function getAvailableTags(filterText) {
        loadingTags = true;
        try {
            const resp = await get(`${availableTagsUrl}?q=${filterText}`);
            const results = await resp.json();
            availableTags = results.results;
            availableTags = results.results.map((tag) => {return {name: tag}});
        }
        catch (err) {
            console.log(err);
        }

        loadingTags = false;
    }

    function loadOptions(filterText) {
        return new Promise(async (resolve, reject) => {
            await getAvailableTags(filterText);
        })
    }

    const optionIdentifier = 'name';
    const getOptionLabel = (option) => option.name;
    const getSelectionLabel = (option) => option.name;
    function createItem(filterText) {
        return {'name': filterText};
    }

    async function saveTags() {

        if (elementTags !== undefined && elementTags.length > 10) { // Only 10 tags allowed by server so don't try to save an 11th one.
            elementTags.pop();
            elementTags = elementTags;
            tagLimitExceeded = true;
        }
        else {
            tagLimitExceeded = false;

            loadingTags = true;
            const method = 'PATCH';

            const toSave = elementTags === undefined ? [] : elementTags.map((tag) => tag.name);
            const jsonData = {
                tags: toSave
            };

            try {
                await submit(setElementTagsUrl, method, jsonData);
            } catch (err) {
                console.error(err);
            } finally {
                loadingTags = false;
            }
        }




    }

</script>

<style>
    .tag-select :global(.clearSelect){
        display: flex;
        justify-content: center;
    }

    .tag-select :global(.clearSelect svg){
        height: 20px;
    }
</style>

{#if readOnly}
    <div class="d-flex">
        {#each elementTags as tag}
            <div class="badge badge-pill badge-secondary mr-1 mb-1">{tag.name}</div>
        {/each}
    </div>
{:else}
    <div class="tag-select">    
        <Select
            {optionIdentifier}
            {getSelectionLabel}
            {getOptionLabel}
            {createItem}
            {loadOptions}
            {MultiSelection}
            bind:items={availableTags}
            bind:selectedValue={elementTags}
            bind:isWaiting={loadingTags}
            isMulti={true}
            {isDisabled}
            isCreatable={true}
            on:select={saveTags}
            on:clear={saveTags}>
        </Select>
    </div>
    {#if tagLimitExceeded}
        <p class="text-danger">{sgettext('$$MAX_TAG_LIMIT_EXCEEDED$$')}</p>
    {/if}
{/if}
